import React from "react"
import { Row, Col, Input } from "reactstrap"
import debounce from "lodash/debounce"
import AdvancedFiltersControl from "../../Filters/AdvancedFiltersControl"
import AppliedAdvancedFilters from "../../Filters/AppliedAdvancedFilters"

const PaymentSchedulesListHeader = ({ filterValues, setFilterValues, presets, setPresets }) => {
    const updateSearchTerm = debounce((searchTerm) => {
        setFilterValues({ ...filterValues, searchTerm })
    }, 500)

    return (
        <Row className="align-items-center">
            <Col xs={4}>
                <span className="driver-search-filter">
                    <Input type="text" name="searchTerm" placeholder="Search" onChange={(e) => updateSearchTerm(e.target.value)} />
                    <i className="fa fa-lg fa-search search-icon" aria-hidden="true"></i>
                </span>
            </Col>
            <Col xs="auto" className="p-0">
                <AdvancedFiltersControl entity="payment_schedule" presets={presets} setPresets={setPresets} />
            </Col>
            <Col />
            <Col xs={12} className="mt-2 search-filter-container">
                <AppliedAdvancedFilters
                    entity="payment_schedule"
                    context={null}
                    presets={presets}
                    onPresetsChange={setPresets}
                />
            </Col>
        </Row>
    )
}

export default PaymentSchedulesListHeader
